import React, { useEffect } from 'react';
import {Grid,Box,Typography, IconButton} from '@mui/material'
import {useState} from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';



const Index = (props:any) => {
    const navigate=useNavigate();
    const dispatch=useDispatch()
    const[tenantId,setTenantId]=useState<string>();
  
   
    
    const onFailed=():void=>{
    
    }
    
  
   
    const[currenPriod,setCurrentPeriod]=useState<object|null>({});
  
    // console.log(priodData)
  
  const userTenantsData=useSelector((state:any)=>state.loign.userInfo.userTenants);
  
  
  
      const initialClose=()=>{
          props.handleClose()
      }
  
  
    return (
     
      <Grid  >
     <Grid container  >
  
     <Grid item xs={12} >
     <Box  padding={2}  margin={1}  borderRadius={10}
   boxShadow={10} >
      <Box>
      <Typography variant='h1' fontSize={'20px'} color={'red'} fontWeight={900}>
     معرفی ما:
      </Typography>
      </Box>
     <Box marginTop={1}>
      <Typography variant='h6' fontSize={'17px'} color={'block'}  >
     برند OKRcoach یکی از برند های شرکت داده بینش خردمند است.مجموعه OKRcoach ارائه دهنده خدمات تخصصی حوزه OKRدر ایران است و تا به حال افتخار داشته ایم در شرکت های مختلف و بزرگ ایرانی ،این روش را با موفقیت پیاده سازی نماییم. 
     (<a target='-blank' href='https://okrcoach.ir/customers'> لیست مشتریان</a>)
     </Typography>
     </Box>
     <Box >
     <Typography variant='h6' fontSize={'17px'} color={'block'} marginTop={1}>
      یکی از مشکلاتی که ما در پیاده سازیOKR داشتیم استفاده از یک نرم افزار مناسب برای شرکت های ایرانی بود تا بتوانیم چرخهOKR را بصورت بهینه ای پیاده سازی کنیم. طی دو نسل به نرم افزار حاضر رسیده ایم، در اولین قدم نرم افزاری ویندوزی روانه 
      بازار شد و در نسل دوم نسخه موبایل و وب که در حال حاضر در حال استفاده از آن هستید به بازار عرضه شده است. 
      </Typography>
      </Box>     
     
      
      <Box>
      <Typography variant='h6' fontSize={'17px'} color={'block'} marginTop={1}> 
      نقطه قوت این نرم افزار این است که تمام ویژگی های موجود بر مبنای تجربیات علمی 
      و نیاز های واقعی مشتریان طراحی و پیاده سازی شده است و ما علت موفقیت خود را تمرکز بر این موضوع می دانیم.
      </Typography>
      </Box>
      <Box textAlign={'justify'} marginTop={1}>
        <Typography variant='h6' fontSize={'17PX'} color={'block'}>
      مجموعه OKRcoach در سه زمینه فعالیت می کند:
      <Box margin={1} >1-مربیگری OKRو کمک به شرکت ها جهت پیاده سازی صحیح روش OKRجهت بهره برداری  حداکثری از مزایای این روش </Box>
      <Box margin={1} > 2-ارائه نرم افزار تخصصی مدیریت چرخهOKRتحت عنوانOKRcoach </Box>
      <Box margin={1} > 3-ارائه آموزش های تخصصی شرکتی و عمومی مرتبط با OKRو مهارت های نرم مرتبط با این حوزه</Box>
      </Typography>
      </Box>
      <Box>
  <Box textAlign={'justify'}  >
  <Typography variant='h6' fontSize={'17px'} color={'block'} marginTop={1}>
    لطفا برای ارتباط با ما از روش های زیر اقدام نمایید:
   <Box margin={1}>1-سایتOKRcoach</Box> 
   <Box margin={1}> 2-ارتباط با پشتیبان مجموعه در شبکه های اجتماعی با شماره تلفن همراه 09370687641</Box>
   <Box margin={1}> 3-مراجعه به باشگاه مشتریان به آدرس:   <a target='-blank' href='https://panel.myokr.ir'>https://panel.myokr.ir</a></Box>

        </Typography>
        </Box>
      </Box>
      </Box>
     </Grid>
  
     </Grid>
      </Grid>
   
  
    )
  }
  
  export default Index
// import React, { useState } from 'react';
// import { useTable } from 'react-table';
// import { jsPDF } from 'jspdf';
// import html2canvas from 'html2canvas';

// interface TableData {
//   [key: string]: string;
// }

// const Index: React.FC = () => {
//   const [columns, setColumns] = useState<string[]>([]);
//   const [rows, setRows] = useState<TableData[]>([]);
//   const [newColumn, setNewColumn] = useState<string>('');
//   const [newRow, setNewRow] = useState<TableData>({});

//   const addColumn = () => {
//     if (newColumn && !columns.includes(newColumn)) {
//       setColumns([...columns, newColumn]);
//     }
//     setNewColumn('');
//   };

//   const addRow = () => {
//     if (Object.keys(newRow).length === columns.length) {
//       setRows([...rows, newRow]);
//       setNewRow({});
//     } else {
//       alert('لطفا همه ستون‌ها را پر کنید');
//     }
//   };

//   const generatePDF = async () => {
//     const input = document.getElementById('report');
//     if (!input) return;

//     const canvas = await html2canvas(input, { useCORS: true });
//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const imgWidth = 210; // عرض A4
//     const pageHeight = 295; // ارتفاع A4
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     let heightLeft = imgHeight;
//     let position = 0;

//     pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     while (heightLeft > 0) {
//       position = heightLeft - imgHeight;
//       pdf.addPage();
//       pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     pdf.save('report.pdf');
//   };

//   const data = React.useMemo(() => rows, [rows]);
//   const columnDefinitions = React.useMemo(() => columns.map((col) => ({ Header: col, accessor: col })), [columns]);

//   const { getTableProps, getTableBodyProps, headerGroups, rows: tableRows, prepareRow } = useTable({
//     columns: columnDefinitions,
//     data,
//   });

//   return (
//     <div className="container">
//       <h2>مدیریت جدول</h2>
//       <div className="input-group">
//         <input
//           type="text"
//           value={newColumn}
//           onChange={(e) => setNewColumn(e.target.value)}
//           placeholder="عنوان ستون جدید"
//           className="input"
//         />
//         <button onClick={addColumn} className="button">افزودن ستون</button>
//       </div>

//       <div className="input-group">
//         {columns.map((col) => (
//           <input
//             key={col}
//             type="text"
//             value={newRow[col] || ''}
//             onChange={(e) => setNewRow({ ...newRow, [col]: e.target.value })}
//             placeholder={`مقدار ستون ${col}`}
//             className="input"
//           />
//         ))}
//         <button onClick={addRow} className="button">افزودن ردیف</button>
//       </div>

//       <div id="report">
//         <table {...getTableProps()} className="table">
//           <thead>
//             {headerGroups.map((headerGroup) => (
//               <tr {...headerGroup.getHeaderGroupProps()} className="table-header">
//                 {headerGroup.headers.map((column) => (
//                   <th {...column.getHeaderProps()} className="table-header-cell">
//                     {column.render('Header')}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>
//           <tbody {...getTableBodyProps()}>
//             {tableRows.map((row) => {
//               prepareRow(row);
//               return (
//                 <tr {...row.getRowProps()} className="table-row">
//                   {row.cells.map((cell) => (
//                     <td {...cell.getCellProps()} className="table-cell">
//                       {cell.render('Cell')}
//                     </td>
//                   ))}
//                 </tr>
//               );
//             })}
//           </tbody>
//         </table>
//       </div>

//       <button onClick={generatePDF} className="button">دانلود PDF</button>

//       {/* استایل‌های CSS به صورت داخلی */}
//       <style>
//         {`
//           body {
//             font-family: Arial, sans-serif;
//             background-color: #f5f5f5;
//             margin: 0;
//             padding: 20px;
//           }

//           .container {
//             background: white;
//             padding: 20px;
//             border-radius: 8px;
//             box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
//           }

//           h2 {
//             color: #333;
//             margin-bottom: 20px;
//           }

//           .input-group {
//             margin-bottom: 15px;
//           }

//           .input {
//             padding: 10px;
//             border: 1px solid #ddd;
//             border-radius: 4px;
//             width: calc(100% - 120px);
//             margin-right: 10px;
//           }

//           .button {
//             padding: 10px 15px;
//             background-color: #007bff;
//             color: white;
//             border: none;
//             border-radius: 4px;
//             cursor: pointer;
//             transition: background-color 0.3s;
//           }

//           .button:hover {
//             background-color: #0056b3;
//           }

//           .table {
//             width: 100%;
//             border-collapse: collapse;
//             margin-top: 20px;
//           }

//           .table-header {
//             background-color: #f2f2f2;
//           }

//           .table-header-cell, .table-cell {
//             border: 1px solid #ddd;
//             padding: 8px;
//             text-align: left;
//           }

//           .table-row:hover {
//             background-color: #f1f1f1;
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default Index;
// import React, { useState } from 'react';
// import { useTable } from 'react-table';
// import { jsPDF } from 'jspdf';
// import html2canvas from 'html2canvas';
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
//   Button, TextField, Box
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { tableCellClasses } from '@mui/material/TableCell';

// interface TableData {
//   [key: string]: string;
// }

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: theme.palette.common.black,
//     color: '#00387C', // تغییر رنگ متن به #00387C
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//     color: '#00387C', // تغییر رنگ متن به #00387C
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:nth-of-type(odd)': {
//     backgroundColor: theme.palette.action.hover,
//   },
//   '&:last-child td, &:last-child th': {
//     border: 0,
//   },
// }));

// const StyledButton = styled(Button)({
//   backgroundColor: '#00387C',
//   width:'80px',
//   color: '#FFFFFF',
//   '&:hover': {
//     backgroundColor: '#002A5C',
//   },
//   marginLeft: '8px', // فاصله دادن بین دکمه‌ها
// });

// const Index: React.FC = () => {
//   const [columns, setColumns] = useState<string[]>([]);
//   const [rows, setRows] = useState<TableData[]>([]);
//   const [newColumn, setNewColumn] = useState<string>('');
//   const [newRow, setNewRow] = useState<TableData>({});

//   const addColumn = () => {
//     if (newColumn && !columns.includes(newColumn)) {
//       setColumns([...columns, newColumn]);
//     }
//     setNewColumn('');
//   };

//   const addRow = () => {
//     if (Object.keys(newRow).length === columns.length) {
//       setRows([...rows, newRow]);
//       setNewRow({});
//     } else {
//       alert('لطفا همه ستون‌ها را پر کنید');
//     }
//   };

//   const generatePDF = async () => {
//     const input = document.getElementById('report');
//     if (!input) {
//         console.error('Element with ID "report" not found.');
//         return;
//     }

//     try {
//         const canvas = await html2canvas(input);
//         const imgData = canvas.toDataURL('image/png');
//         const pdf = new jsPDF('p', 'mm', 'a4');

//         const imgWidth = 190;
//         const pageHeight = 295;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;

//         let heightLeft = imgHeight;
//         let position = 0;

//         pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
//         heightLeft -= pageHeight;

//         while (heightLeft >= 0) {
//             position = heightLeft - imgHeight;
//             pdf.addPage();
//             pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
//             heightLeft -= pageHeight;
//         }

//         pdf.save('report.pdf');
//     } catch (error) {
//         console.error('Error generating PDF:', error);
//     }
//   };

//   const data = React.useMemo(() => rows, [rows]);
//   const columnDefinitions = React.useMemo(() => columns.map((col) => ({ Header: col, accessor: col })), [columns]);

//   const { getTableProps, getTableBodyProps, headerGroups, rows: tableRows, prepareRow } = useTable({
//     columns: columnDefinitions,
//     data,
//   });

//   return (
//     <div className="container">
//       <h2 style={{ color: '#00387C' }}>مدیریت جدول</h2>
//       <Box display="flex" mb={2}>
//         <TextField
//           label="عنوان ستون جدید"
//           value={newColumn}
//           onChange={(e) => setNewColumn(e.target.value)}
//           variant="outlined"
//           fullWidth
//           margin="normal"
//         />
//         <StyledButton variant="contained" onClick={addColumn}>
//           افزودن ستون
//         </StyledButton>
//       </Box>

//       <Box display="flex" mb={2}>
//         {columns.map((col) => (
//           <TextField
//             key={col}
//             label={`مقدار ستون ${col}`}
//             value={newRow[col] || ''}
//             onChange={(e) => setNewRow({ ...newRow, [col]: e.target.value })}
//             variant="outlined"
//             margin="normal"
//           />
//         ))}
//         <StyledButton variant="contained" onClick={addRow}>
//           افزودن ردیف
//         </StyledButton>
//       </Box>

//       <TableContainer component={Paper} id="report">
//         <Table {...getTableProps()} sx={{ minWidth: 700 }}>
//           <TableHead>
//             {headerGroups.map((headerGroup) => (
//               <TableRow {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map((column) => (
//                   <StyledTableCell {...column.getHeaderProps()}>
//                     {column.render('Header')}
//                   </StyledTableCell>
//                 ))}
//               </TableRow>
//             ))}
//           </TableHead>
//           <TableBody {...getTableBodyProps()}>
//             {tableRows.map((row) => {
//               prepareRow(row);
//               return (
//                 <StyledTableRow {...row.getRowProps()}>
//                   {row.cells.map((cell) => (
//                     <StyledTableCell {...cell.getCellProps()}>
//                       {cell.render('Cell')}
//                     </StyledTableCell>
//                   ))}
//                 </StyledTableRow>
//               );
//             })}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <StyledButton variant="contained" onClick={generatePDF}>
//         دانلود PDF
//       </StyledButton>
//     </div>
//   );
// };

// export default Index;
